import { vars } from "nativewind";

const VARS = {
	"--color-primary-0": "255 254 250",
	"--color-primary-50": "255 254 246",
	"--color-primary-100": "255 254 221",
	"--color-primary-200": "255 253 187",
	"--color-primary-300": "255 253 153",
	"--color-primary-400": "255 252 127",
	"--color-primary-500": "255 251 85",
	"--color-primary-600": "255 251 10",
	"--color-primary-700": "224 221 0",
	"--color-primary-800": "184 181 0",
	"--color-primary-900": "122 120 0",
	"--color-primary-950": "82 80 0",

	"--color-secondary-0": "242 245 245",
	"--color-secondary-50": "204 212 213",
	"--color-secondary-100": "153 169 171",
	"--color-secondary-200": "102 126 129",
	"--color-secondary-300": "51 83 87",
	"--color-secondary-400": "26 62 66",
	"--color-secondary-500": "0 40 45",
	"--color-secondary-600": "0 37 41",
	"--color-secondary-700": "0 32 36",
	"--color-secondary-800": "0 28 32",
	"--color-secondary-900": "0 20 23",
	"--color-secondary-950": "0 12 14",

	"--color-tertiary-0": "247 252 253",
	"--color-tertiary-50": "244 251 252",
	"--color-tertiary-100": "241 251 251",
	"--color-tertiary-200": "236 249 249",
	"--color-tertiary-300": "233 248 249",
	"--color-tertiary-400": "231 247 248",
	"--color-tertiary-500": "228 246 247",
	"--color-tertiary-600": "208 239 241",
	"--color-tertiary-700": "161 224 227",
	"--color-tertiary-800": "114 208 213",
	"--color-tertiary-900": "46 152 158",
	"--color-tertiary-950": "27 130 136",

	"--color-neutral-0": "255 255 255",
	"--color-neutral-50": "243 243 243",
	"--color-neutral-100": "229 229 229",
	"--color-neutral-200": "219 219 220",
	"--color-neutral-300": "187 187 187",
	"--color-neutral-400": "163 163 163",
	"--color-neutral-500": "140 140 140",
	"--color-neutral-600": "115 115 115",
	"--color-neutral-700": "82 82 82",
	"--color-neutral-800": "64 64 64",
	"--color-neutral-900": "38 38 39",
	"--color-neutral-950": "23 23 23",
	"--color-neutral-1000": "0 0 0",

	"--color-charge1v1-0": "255 255 255",
	"--color-charge1v1-50": "253 255 248",
	"--color-charge1v1-100": "250 255 240",
	"--color-charge1v1-200": "248 255 233",
	"--color-charge1v1-300": "243 255 218",
	"--color-charge1v1-400": "238 255 203",
	"--color-charge1v1-500": "231 255 181",
	"--color-charge1v1-600": "223 255 153",
	"--color-charge1v1-700": "210 255 112",
	"--color-charge1v1-800": "176 223 74",
	"--color-charge1v1-900": "150 203 38",
	"--color-charge1v1-950": "125 184 1",

	"--color-charge2v1-0": "255 255 255",
	"--color-charge2v1-50": "255 255 248",
	"--color-charge2v1-100": "255 255 241",
	"--color-charge2v1-200": "255 254 234",
	"--color-charge2v1-300": "255 254 220",
	"--color-charge2v1-400": "255 254 206",
	"--color-charge2v1-500": "255 253 185",
	"--color-charge2v1-600": "255 253 153",
	"--color-charge2v1-700": "255 252 127",
	"--color-charge2v1-800": "255 251 85",
	"--color-charge2v1-900": "255 251 10",
	"--color-charge2v1-950": "224 221 0",

	"--color-charge3v1-0": "255 255 255",
	"--color-charge3v1-50": "255 253 248",
	"--color-charge3v1-100": "255 250 241",
	"--color-charge3v1-200": "255 248 235",
	"--color-charge3v1-300": "255 243 221",
	"--color-charge3v1-400": "255 239 207",
	"--color-charge3v1-500": "255 232 187",
	"--color-charge3v1-600": "255 221 153",
	"--color-charge3v1-700": "255 207 112",
	"--color-charge3v1-800": "255 194 72",
	"--color-charge3v1-900": "255 180 32",
	"--color-charge3v1-950": "204 136 0",

	"--color-charge1v2-0": "240 255 248",
	"--color-charge1v2-50": "186 255 222",
	"--color-charge1v2-100": "132 255 197",
	"--color-charge1v2-200": "78 255 172",
	"--color-charge1v2-300": "25 255 146",
	"--color-charge1v2-400": "0 226 119",
	"--color-charge1v2-500": "0 136 72",
	"--color-charge1v2-600": "0 113 60",
	"--color-charge1v2-700": "0 90 47",
	"--color-charge1v2-800": "0 67 35",
	"--color-charge1v2-900": "0 44 23",
	"--color-charge1v2-950": "0 20 11",

	"--color-charge2v2-0": "240 245 255",
	"--color-charge2v2-50": "224 236 255",
	"--color-charge2v2-100": "194 216 255",
	"--color-charge2v2-200": "143 184 255",
	"--color-charge2v2-300": "92 152 255",
	"--color-charge2v2-400": "51 126 255",
	"--color-charge2v2-500": "22 108 255",
	"--color-charge2v2-600": "0 85 230",
	"--color-charge2v2-700": "0 67 183",
	"--color-charge2v2-800": "0 50 135",
	"--color-charge2v2-900": "0 32 88",
	"--color-charge2v2-950": "0 15 41",

	"--color-charge3v2-0": "255 255 255",
	"--color-charge3v2-50": "236 239 239",
	"--color-charge3v2-100": "189 199 201",
	"--color-charge3v2-200": "128 148 150",
	"--color-charge3v2-300": "66 96 99",
	"--color-charge3v2-400": "19 56 61",
	"--color-charge3v2-500": "0 40 45",
	"--color-charge3v2-600": "0 37 42",
	"--color-charge3v2-700": "0 31 35",
	"--color-charge3v2-800": "0 23 26",
	"--color-charge3v2-900": "0 17 19",
	"--color-charge3v2-950": "0 14 16",

	"--color-turquoise-0": "245 255 254",
	"--color-turquoise-50": "235 255 253",
	"--color-turquoise-100": "185 255 253",
	"--color-turquoise-200": "96 255 249",
	"--color-turquoise-300": "0 251 245",
	"--color-turquoise-400": "0 231 230",
	"--color-turquoise-500": "0 198 201",
	"--color-turquoise-600": "0 158 164",
	"--color-turquoise-700": "0 124 131",
	"--color-turquoise-800": "0 98 102",
	"--color-turquoise-900": "0 80 84",
	"--color-turquoise-950": "0 42 47",

	"--color-orange-0": "255 251 247",
	"--color-orange-50": "255 246 236",
	"--color-orange-100": "255 231 212",
	"--color-orange-200": "255 203 168",
	"--color-orange-300": "255 166 110",
	"--color-orange-400": "255 135 77",
	"--color-orange-500": "255 75 0",
	"--color-orange-600": "250 39 0",
	"--color-orange-700": "207 20 0",
	"--color-orange-800": "165 18 2",
	"--color-orange-900": "134 23 8",
	"--color-orange-950": "73 8 4",

	"--color-green-0": "244 255 250",
	"--color-green-50": "234 255 244",
	"--color-green-100": "203 255 233",
	"--color-green-200": "150 255 210",
	"--color-green-300": "0 255 176",
	"--color-green-400": "0 255 132",
	"--color-green-500": "0 233 96",
	"--color-green-600": "0 195 75",
	"--color-green-700": "0 161 66",
	"--color-green-800": "0 119 56",
	"--color-green-900": "0 98 47",
	"--color-green-950": "0 55 25",

	"--color-blue-0": "245 253 255",
	"--color-blue-50": "236 250 255",
	"--color-blue-100": "217 245 255",
	"--color-blue-200": "167 237 255",
	"--color-blue-300": "67 223 255",
	"--color-blue-400": "0 207 255",
	"--color-blue-500": "0 190 255",
	"--color-blue-600": "0 148 219",
	"--color-blue-700": "0 117 177",
	"--color-blue-800": "0 100 145",
	"--color-blue-900": "0 83 119",
	"--color-blue-950": "0 52 79",

	"--color-success-0": "247 255 246",
	"--color-success-50": "242 255 240",
	"--color-success-100": "219 252 213",
	"--color-success-200": "176 250 173",
	"--color-success-300": "129 241 135",
	"--color-success-400": "96 227 115",
	"--color-success-500": "48 209 88",
	"--color-success-600": "35 179 84",
	"--color-success-700": "24 150 79",
	"--color-success-800": "15 121 72",
	"--color-success-900": "9 100 67",
	"--color-success-950": "40 48 45",

	"--color-error-0": "251 233 233",
	"--color-error-50": "248 211 212",
	"--color-error-100": "244 189 190",
	"--color-error-200": "240 167 169",
	"--color-error-300": "233 123 126",
	"--color-error-400": "225 79 83",
	"--color-error-500": "218 35 40",
	"--color-error-600": "182 24 42",
	"--color-error-700": "147 15 41",
	"--color-error-800": "121 9 40",
	"--color-error-900": "93 25 43",
	"--color-error-950": "65 40 47",

	"--color-warning-0": "255 253 247",
	"--color-warning-50": "255 252 240",
	"--color-warning-100": "255 249 221",
	"--color-warning-200": "255 243 187",
	"--color-warning-300": "255 234 153",
	"--color-warning-400": "255 226 127",
	"--color-warning-500": "255 212 85",
	"--color-warning-600": "219 175 62",
	"--color-warning-700": "183 140 42",
	"--color-warning-800": "147 107 27",
	"--color-warning-900": "108 56 19",
	"--color-warning-950": "72 68 63",

	"--color-info-0": "247 252 253",
	"--color-info-50": "244 251 252",
	"--color-info-100": "241 251 251",
	"--color-info-200": "236 249 249",
	"--color-info-300": "233 248 249",
	"--color-info-400": "231 247 248",
	"--color-info-500": "228 246 247",
	"--color-info-600": "208 239 241",
	"--color-info-700": "161 224 227",
	"--color-info-800": "114 208 213",
	"--color-info-900": "66 192 199",
	"--color-info-950": "46 152 158",

	"--color-brand-auchan": "225 0 10",
	"--color-brand-decathlon": "55 67 186",
	"--color-brand-leroyMerlin": "123 181 28",
	"--color-brand-cultura": "0 47 108",
};

export const config = {
	light: vars(VARS),
	dark: vars(VARS), // No dark mode for now use same values as light mode
};
